module.exports = __webpack_public_path__ + "static/item1-638154cc68243d1c4febadabb2309984.png";